webpackJsonp([79737414614040],{

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/winston2.abb66261.jpg";

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _work = __webpack_require__(25);
	
	var _work2 = _interopRequireDefault(_work);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var winston = __webpack_require__(467);
	
	var Winston = function Winston() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Winston | Cory Schadt',
	      bodyAttributes: {
	        class: 'inner'
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'page fade' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Winston'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Winston is platform for that allows Instagram users to connect with some of the biggest brands in the world.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Primary Role:  HTML, CSS, Responsive Design, React Component Creation.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'a',
	                { className: 'btn', target: '_blank', href: 'http://winston.social' },
	                'View Project'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'project-feature' },
	        _react2.default.createElement(_work2.default, { noLink: true, raise: true, laptop: true, screen: winston, color: '#2FB9F9' })
	      )
	    )
	  );
	};
	exports.default = Winston;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-winston-js-86ccef3fac406c19a1c2.js